<template>
  <div class="c-range">
    <div v-if="label" class="c-range-label">{{ label }}</div>

    <div class="c-range-wrapper">
      <div class="c-range-control">
        <vue-slider
          v-model="localValue"
          :duration="0.2"
          :bg-style="bgStyle"
          :height="4"
          :process-style="processStyle"
          :dot-size="16"
          :max="+max"
          :min="+min"
          :dot-style="dotStyle"
          :dot-options="dotOptions"
        />
      </div>

      <div class="c-range-values">
        <input v-model="localValue[0]" type="number" class="c-range-input" :min="min" :max="max" step="1" />

        <div class="c-range-separator"></div>

        <input v-model="localValue[1]" type="number" class="c-range-input" :min="min" :max="max" step="1" />
      </div>
    </div>
  </div>
</template>

<script>
import "vue-range-component/dist/vue-range-slider.css";

import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";

// import '@/assets/scss/components/vue-range-slider.scss';

export default {
  name: "c-range",

  components: {
    VueSlider,
  },

  props: ["value", "label", "min", "max"],

  data() {
    return {
      localValue: this.value,

      bgStyle: {
        backgroundColor: "#DFE4EF",
      },

      processStyle: {
        backgroundColor: "#0066FF",
      },

      dotStyle: {
        backgroundColor: "#0066FF",
        border: "none",
      },

      dotOptions: {
        tooltip: "none",
      },
    };
  },

  watch: {
    localValue(value) {
      this.$emit("input", value);
    },

    value(value) {
      this.localValue = value;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.c-range {
  &-label {
    font: {
      size: 12px;
    }
    color: $color-label;
    line-height: 13px;
  }

  &-wrapper {
    margin-top: 13px;
    display: flex;
  }

  &-control {
    width: 220px;
  }

  &-values {
    display: flex;
    align-items: center;
    margin-left: 30px;
  }

  &-separator {
    width: 5px;
    height: 1px;
    background: $color-border;
    margin: -12px 10px 0;
  }

  &-input {
    width: 40px;
    border: none;
    border-bottom: 1px solid $color-border;
    padding-bottom: 13px;
    height: 30px;
    text-align: center;
    font-size: 15px;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    &:focus {
      outline: none;
    }
  }
}
</style>
